import React from 'react';
import { CheckIcon } from 'lucide-react';
import { services } from '../data/services';
export function Services() {
  return <section id="prestations" className="w-full scroll-mt-24 border-t border-sand-200 bg-sand-50 py-20 md:py-28" data-id="element-96" data-mp="1hwxkyg0m4kj5">
      <div className="mx-auto w-full max-w-6xl px-6" data-id="element-97" data-mp="1ds7putds39za">
        <div className="max-w-2xl" data-id="element-98" data-mp="18vhdag16mwim">
          <h2 className="font-display text-4xl leading-tight text-ink sm:text-5xl" data-id="element-99" data-mp="18ufvzttkpdsg">Ce que je fais</h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-100" data-mp="13xfulw7o4z7o">
            Quatre métiers complémentaires, pour traiter un mur abîmé comme un logement entier à
            reprendre.
          </p>
        </div>

        <div className="mt-16 flex flex-col gap-16 md:gap-20" data-id="element-101" data-mp="u3z00pzpjg2y">
          {services.map((service, index) => <article key={service.id} className="grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-14" data-id="element-102" data-mp="l5djf0dsqb4t" data-mpi={index}>
              <img src={service.image} alt={service.imageAlt} loading="lazy" className={`aspect-[4/3] w-full rounded-3xl object-cover ${index % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-103" data-mp="g7le94o54sio" />
              <div data-id="element-104" data-mp="2xcug3f0ae02x">
                <span className="font-display text-sm italic text-brique" data-id="element-105" data-mp="2xdciyuhgfcjt">
                  0{index + 1}
                </span>
                <h3 className="mt-2 font-display text-2xl leading-snug text-ink sm:text-3xl" data-id="element-106" data-mp="328i965hw3ddp">
                  {service.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-ink-soft" data-id="element-107" data-mp="3u10o8bwf3aly">{service.summary}</p>
                <ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-108" data-mp="3g17v69xf4iat">
                  {service.details.map(detail => <li key={detail} className="flex items-start gap-2.5 text-sm text-ink-soft" data-id="element-109" data-mp="3l36wle9ll554">
                      <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brique" aria-hidden="true" data-id="element-110" data-mp="24pgrc46qsatw" />
                      {detail}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}